// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2-p7q","footer":"ModalError_footer__2X1PI"};